import { render, staticRenderFns } from "./sidebar-disclaimers.vue?vue&type=template&id=011a9ed1&scoped=true&"
import script from "./sidebar-disclaimers.vue?vue&type=script&lang=js&"
export * from "./sidebar-disclaimers.vue?vue&type=script&lang=js&"
import style0 from "./sidebar-disclaimers.vue?vue&type=style&index=0&id=011a9ed1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011a9ed1",
  null
  
)

export default component.exports